import { render, staticRenderFns } from "./SpecialistListView.vue?vue&type=template&id=08493486&"
import script from "./SpecialistListView.vue?vue&type=script&lang=js&"
export * from "./SpecialistListView.vue?vue&type=script&lang=js&"
import style0 from "./SpecialistListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports